function getCurrentLocale() {
  const defaultLocale = 'fr';

  let locale = document.documentElement.lang;

  if (locale !== '') {
    return locale;
  }

  let results = window.location.href.match(/^https?:\/\/[^/]+\/\b(fr|en|es)\b\/?/);

  if (results === null) {
    return defaultLocale;
  }

  locale = results[1];

  if (!locale) {
    locale = defaultLocale;
  }

  return locale;
}

function createDebouncer() {
  let timeout;
  return function(func, duration) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(), duration);
  };
}

// Make functions globally available
window.getCurrentLocale = getCurrentLocale;
window.createDebouncer = createDebouncer;
